import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faArrowLeft,
	faArrowRight,
	faBullseye,
	faBullseyePointer,
	faCalendarXmark,
	faCashRegister,
	faGavel,
	faGift,
	faGlobe,
	faHand,
	faPaperPlane,
	faSackDollar,
	faShop,
	faStore,
	faTruck,
	faTruckFast,
} from '@awesome.me/kit-428607b2fd/icons/classic/light'

library.add(
	faArrowLeft,
	faArrowRight,
	faBullseye,
	faBullseyePointer,
	faCalendarXmark,
	faCashRegister,
	faGavel,
	faGift,
	faGlobe,
	faHand,
	faPaperPlane,
	faSackDollar,
	faShop,
	faStore,
	faTruck,
	faTruckFast,
)
